const HamburgerIcon = () => {
    return (
        <svg width="22px" height="18px" viewBox="0 0 22 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Group 7</title>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="Landing-1---option-B" transform="translate(-20, -22)" stroke="#141718" strokeWidth="2">
                    <g id="Group-7" transform="translate(21, 23)">
                        <line x1="0" y1="15.5" x2="20" y2="15.5" id="Stroke-1"></line>
                        <line x1="0" y1="7.5" x2="20" y2="7.5" id="Stroke-3"></line>
                        <line x1="0" y1="0.5" x2="20" y2="0.5" id="Stroke-5"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default HamburgerIcon;
